// -----------------------------------------------------------------------------
// src/features/queries/querySlice.js
// -----------------------------------------------------------------------------
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchClientQueriesThunk,
  createClientQueryThunk,
  updateClientQueryThunk,
} from './queryThunks';

const initialState = {
  queries: [],
  loading: false,
  error: null,
  next: null,
  count: 0,
};

const querySlice = createSlice({
  name: 'queries',
  initialState,
  reducers: {
    resetQueries(state) {
      state.queries = [];
      state.next = null;
      state.count = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch all (paginated)
      .addCase(fetchClientQueriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientQueriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { results, next, count } = action.payload;
        const offset = action.meta.arg?.offset ?? 0;
        if (offset > 0) {
          state.queries.push(...results);
        } else {
          state.queries = results;
        }
        state.next = next;
        state.count = count;
      })
      .addCase(fetchClientQueriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create
      .addCase(createClientQueryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createClientQueryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.queries.unshift(action.payload);
        state.count += 1;
      })
      .addCase(createClientQueryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // update
      .addCase(updateClientQueryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClientQueryThunk.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload;
        const idx = state.queries.findIndex((q) => q.id === updated.id);
        if (idx !== -1) state.queries[idx] = updated;
      })
      .addCase(updateClientQueryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetQueries } = querySlice.actions;
export default querySlice.reducer;
